<template>
  <div class="ma-4">
    <!-- lt: {{ localTable }} -->
    <!-- <v-text-field
      v-model="title"
      label="Title"
      outlined
      dense
      :hide-details="true"
    ></v-text-field> -->
    <div v-if="showPreview && canShowPreview">
      <v-btn-toggle class="my-2" v-model="viewType" mandatory rounded>
        <v-btn small rounded value="edit" active-class="orangeActive"
          ><v-icon small color="primary" class="mr-2">mdi-pencil</v-icon>Edit
          Table</v-btn
        >
        <v-btn small rounded value="table" active-class="orangeActive"
          >Table preview</v-btn
        >
        <v-btn small rounded value="mobile" active-class="orangeActive"
          >Mobile preview</v-btn
        >
      </v-btn-toggle>
      <div
        v-if="viewType != 'edit'"
        class="ma-3 pa-2 d-inline-block"
        style="background-color: yellow"
      >
        Note: The links in the following previews are disabled (to prevent
        accidentally navigating away and potentially losing unsaved work).
      </div>
    </div>
    <div v-if="viewType == 'edit' && localTable">
      <table v-if="localTable.headers">
        <tbody>
          <tr>
            <td v-for="(header, i) in localTable.headers" :key="'delete' + i">
              <v-btn
                small
                text
                color="primary"
                v-if="i > 1"
                @click="removeColumn(i)"
                tabindex="-1"
                ><v-icon small color="red" class="mx-1"
                  >mdi-minus-circle</v-icon
                >
                Column</v-btn
              >
              <v-btn
                v-if="i == localTable.headers.length - 1"
                @click="addColumn()"
                small
                text
                color="primary"
                tabindex="-1"
              >
                <v-icon small color="green" class="mx-1"
                  >mdi-plus-circle</v-icon
                >
                Column</v-btn
              >
            </td>
            <td></td>
          </tr>
          <tr>
            <td
              v-for="(header, h) in localTable.headers"
              :key="'header_' + h"
              style="width: 250px; height: 80px"
            >
              <v-textarea
                v-model="localTable.headers[h]"
                outlined
                dense
                :hide-details="true"
                class="headerClass"
              ></v-textarea>
            </td>
            <td></td>
          </tr>
        </tbody>
        <tbody v-for="(group, g) in localTable.groups" :key="'group_' + g">
          <tr v-if="localTable.groups.length > 1" class="">
            <th :colspan="localTable.headers.length" class="text-center">
              <div class="d-flex flex-row">
                <v-text-field
                  v-model="localTable.groups[g].name"
                  outlined
                  dense
                  :hide-details="true"
                ></v-text-field>
                <v-btn small text color="primary" @click="removeGroup(g)"
                  ><v-icon class="mx-1" color="red">mdi-minus-circle</v-icon
                  >Remove Group</v-btn
                >
              </div>
            </th>
          </tr>
          <tr v-for="(row, r) in group.items" :key="'row_' + r">
            <td
              v-for="(column, c) in localTable.headers"
              :key="`cell_${g}_${r}_${c}`"
            >
              <v-textarea
                v-model="localTable.groups[g].items[r][c]"
                outlined
                dense
                :hide-details="true"
              ></v-textarea>
              <!--    :label="`cell_${g}_${r}_${c}`" -->
            </td>
            <td>
              <v-btn
                tabindex="-1"
                class="ml-1"
                color="primary"
                text
                small
                v-if="r > 0"
                @click="removeRow(g, r)"
                ><v-icon color="red" small class="mx-1"
                  >mdi-minus-circle</v-icon
                >
                Row</v-btn
              ><br />
              <v-btn
                tabindex="-1"
                class="ml-1"
                text
                color="primary"
                small
                v-if="r == localTable.groups[g].items.length - 1"
                @click="addRow(g)"
                ><v-icon color="green" small class="mx-1"
                  >mdi-plus-circle</v-icon
                >
                Row</v-btn
              >
            </td>
          </tr>
        </tbody>
      </table>
      <v-btn @click="addGroup()" text color="primary" class="my-1"
        >Add Group</v-btn
      >

      <div class="mt-4 overline">Table Notes</div>
      <md-textarea
        v-model="localTable.notes"
        label="Notes"
        class="my-3"
        style="max-width: 800px"
      ></md-textarea>
    </div>

    <div v-if="canShowPreview && viewType == 'table'">
      <v-card class="pa-2">
        <data-table
          :title="title"
          :headers="tableData.headers"
          :groups="tableData.groups"
          :notes="tableData.notes"
          :notesClass="null"
          :deactivateLinks="deactivatePreviewLinks"
        ></data-table>
      </v-card>
    </div>
    <div v-if="canShowPreview && viewType == 'mobile'">
      <v-card width="350" class="pa-2">
        <data-table-mobile
          :title="title"
          :headers="tableData.headers"
          :groups="tableData.groups"
          :notes="tableData.notes"
          :notesClass="null"
          :deactivateLinks="deactivatePreviewLinks"
          :showTitle="true"
        ></data-table-mobile>
      </v-card>
    </div>
  </div>
</template>
<script>
import DataTable from "@/components/pagesStuff/DataTable";
import DataTableMobile from "@/components/pagesStuff/DataTableMobile.vue";

// import Name from "../dir/file";
// import VueMarkdown from "@adapttive/vue-markdown";
import MdTextarea from "@/components/adminStuff/MdTextarea";

export default {
  name: "TableMaker",
  components: {
    DataTable,
    // VueMarkdown,
    MdTextarea,
    DataTableMobile,
  },
  props: {
    showPreview: { type: Boolean, default: true },
    tableData: null,
    title: null,
    deactivatePreviewLinks: null,
  },
  data: function () {
    return {
      viewType: "table",
      localTable: {
        headers: ["Header 1", "Header 2"],
        groups: [
          {
            name: "",
            items: [
              ["data", "data"],
              ["data", "data"],
            ],
          },
        ],
        notes: "",
      },
    };
  },
  methods: {
    addColumn() {
      this.localTable.headers.push("");
      this.localTable.groups.forEach((group) => {
        group.items.forEach((row) => {
          row.push("");
        });
      });
    },
    removeColumn(index) {
      let c = confirm(
        "Are you sure you want to remove this row? This will remove all the cells in this row."
      );
      if (c) {
        this.localTable.headers.splice(index, 1);
        this.localTable.groups.forEach((group) => {
          group.items.forEach((row) => {
            row.splice(index, 1);
          });
        });
      }
    },
    removeRow(group, row) {
      let c = confirm(
        "Are you sure you want to remove this row? This will remove all the cells in this row."
      );
      if (c) this.localTable.groups[group].items.splice(row, 1);
    },
    addRow(group) {
      let size = this.localTable.headers.length;
      this.localTable.groups[group].items.push(Array(size).fill(""));
    },
    addGroup() {
      let size = this.localTable.headers.length;
      this.localTable.groups.push({
        name: "Group " + (this.localTable.groups.length + 1),
        items: [Array(size).fill("")],
      });
      if (this.localTable.groups.length > 1 && !this.localTable.groups[0].name)
        this.localTable.groups[0].name = "Group 1";
    },
    removeGroup(index) {
      let c = confirm(
        "Are you sure you want to remove this group? This will remove all the cells in this group."
      );
      if (c) {
        this.localTable.groups.splice(index, 1);
      }
    },
  },
  computed: {
    canShowPreview: function () {
      return this.showPreview && this.tableData?.headers?.length > 0;
    },
  },
  watch: {
    localTable: {
      handler(val) {
        this.$emit("table", val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.tableData) {
      // clone the tabledata object to the localTable object
      this.localTable = JSON.parse(JSON.stringify(this.tableData));
    } else {
      this.$emit("table", this.localTable);
    }
    if (!this.showPreview) this.viewType = "edit";
  },
};
</script>

<style scoped>
.headerClass {
  background-color: #f0f9ff;
}
</style>
